module.exports = __webpack_public_path__ + "assets/vehicle_map_van.830f8a9f.svg";